var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { ConsentStatus } from "healthex-common/consent.dtos";
import { NOT_LOADED } from "../Infra/RemoteData";
export class PatientConsentInformedConsentViewModel extends PatientConsentViewModel {
    constructor() {
        super(...arguments);
        this.previewType = null;
    }
    get isScreenshotMode() {
        return this.patientConsentUIManager.isScreenshotMode;
    }
    get consentFlowPageData() {
        if (!this.isScreenshotMode)
            return null;
        return this.patientConsentUIManager.consentFlowPageData;
    }
    get patientInformedConsentEnabled() {
        var _a, _b;
        if (this.previewType === "optedIn")
            return true;
        if (this.previewType === "optedOut")
            return false;
        if (this.previewType === "imInterested")
            return null;
        if ((_a = this.consentFlowPageData) === null || _a === void 0 ? void 0 : _a.consentStatus) {
            return ((_b = this.consentFlowPageData) === null || _b === void 0 ? void 0 : _b.consentStatus) === ConsentStatus.OPTED_IN;
        }
        else {
            return this.patientConsentUIManager.session.patientInformedConsentEnabled;
        }
    }
    get patientIsInterested() {
        if (this.previewType === "imInterested")
            return true;
        return this.patientConsentUIManager.session.isInterested;
    }
    get continueButtonEnabled() {
        return this.patientInformedConsentEnabled !== null || this.patientIsInterested === true;
    }
    get optionButtonsEnabled() {
        return !this.patientConsentUIManager.session.isSubmittingConsent;
    }
    get showIsInterestedButton() {
        if (this.previewType === "imInterested")
            return true;
        if (this.study === NOT_LOADED || !this.study)
            return false;
        return !!this.study.informedConsentInterested;
    }
    updateInformedConsentEnabled(isConsented, isInterested) {
        this.patientConsentUIManager.updatePatientInformedConsentEnabled(isConsented, isInterested);
    }
    async confirmConsent() {
        if (this.patientIsInterested === true) {
            await this.patientConsentUIManager.confirmImInterested();
        }
        else if (this.patientInformedConsentEnabled === true) {
            this.goToNextPage();
        }
        else {
            await this.patientConsentUIManager.declineConsent();
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientConsentInformedConsentViewModel.prototype, "previewType", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInformedConsentViewModel.prototype, "isScreenshotMode", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInformedConsentViewModel.prototype, "consentFlowPageData", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInformedConsentViewModel.prototype, "patientInformedConsentEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInformedConsentViewModel.prototype, "patientIsInterested", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInformedConsentViewModel.prototype, "continueButtonEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInformedConsentViewModel.prototype, "optionButtonsEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInformedConsentViewModel.prototype, "showIsInterestedButton", null);
